import { render, staticRenderFns } from "./ListRegional.vue?vue&type=template&id=63ebd91a&scoped=true&"
import script from "./ListRegional.vue?vue&type=script&lang=js&"
export * from "./ListRegional.vue?vue&type=script&lang=js&"
import style0 from "./ListRegional.vue?vue&type=style&index=0&id=63ebd91a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ebd91a",
  null
  
)

export default component.exports